import { create } from 'zustand';

const useAuthStore = create((set) => ({
  token: localStorage.getItem('jwt_token') || null,
  user_id: null,
  balance: 0,
  wallet_address: null,
  isAuthenticated: !!localStorage.getItem('jwt_token'),
  setToken: (token) => {
    localStorage.setItem('jwt_token', token);
    set({ token, isAuthenticated: true });
  },
  setUser: (user) => set({ user_id: user.user_id, balance: user.balance, wallet_address: user.wallet_address }),
  logout: () => {
    localStorage.removeItem('jwt_token');
    set({ token: null, user_id: null, balance: 0, wallet_address: null, isAuthenticated: false });
  },
  updateBalance: (balance) => set({ balance }),
}));

export default useAuthStore;
